import { NavigationItem } from '@models';

export const NavigationConfig: NavigationItem[] = [
  { label: 'Home', route: '#', icon: 'home' },
  {
    label: 'Protocols',
    icon: 'clipboard-list',
    route: 'protocols',
    children: [
      { label: 'FM Protocols', route: 'fm-protocols' },
      { label: 'Tx Protocols', route: 'tx-protocols' },
    ],
  },
  { label: 'Education', route: 'education', icon: 'education' },
  { label: 'Support management', route: 'support', icon: 'life-saver' },
  { label: 'Providers', route: 'providers', icon: 'users-group' },
  { label: 'Patients', route: 'patients', icon: 'users' },
];
